import { DataGridSettings } from '../../../../interfaces/DataGrid/DataGridSettings'

export const dataGridSettings: DataGridSettings = {
  spacing: 1,
  sortingMode: 'single',
  columns: [
    {
      title: '',
      dataField: 'expand',
      xs: 12,
      sm: 1,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'LPN',
      dataField: 'lpn',
      xs: 12,
      sm: 1,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'Producto',
      dataField: 'producto',
      xs: 12,
      sm: 2,
      lg: 2,
      allowSorting: false
    },
    {
      title: 'Nombre',
      dataField: 'nombre',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: false
    },
    {
      title: 'Venta En Verde',
      dataField: 'isPreSaleReception',
      xs: 12,
      sm: 2,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'C. En Asn',
      dataField: 'RealQty',
      xs: 12,
      sm: 2,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'C. Recibido',
      dataField: 'LocatedQty',
      xs: 12,
      sm: 2,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'C. Pendiente De Ajustar',
      dataField: 'DiffereceQty',
      xs: 12,
      sm: 2,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'Acciones',
      dataField: 'Actions',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: false
    }
  ]
}
